import { render } from "./VODBucket.vue?vue&type=template&id=c3ef1cce"
import script from "./VODBucket.vue?vue&type=script&setup=true&lang=js"
export * from "./VODBucket.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/VodDash/VODBucket.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c3ef1cce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c3ef1cce', __exports__)) {
    api.reload('c3ef1cce', __exports__)
  }
  
  module.hot.accept("./VODBucket.vue?vue&type=template&id=c3ef1cce", () => {
    api.rerender('c3ef1cce', render)
  })

}


export default __exports__